@for (message of messages(); track $index) {
	<ds-toast [message]="message" />
}
